import Upload, { UploadType } from '@/components/Upload';
import ToastUtils from '@/utils/ToastUtils';
import { getFileSuffix } from '@/utils';
import { cloneDeep } from 'lodash';

import { Storage } from '@/utils/Storage';

import { agentFileBucketName, getAgentFileDirName, fileStatusDic, parseStatusDic } from '@/utils/Page/constant';
import { getFileTypeBySuffix } from '@/utils';
const FileUpload = (props) => {
    const { setAgentFile, agentFile, UploadConfig = {} } = props;
    const onFileChange = (file) => {
        let ext_type = getFileSuffix(file?.name);
        let type = getFileTypeBySuffix(ext_type);
        let list = [];
        if (agentFile) {
            list = cloneDeep(agentFile);
            list.push({
                type: type,
                open: 0,
                uid: file.uid,
                progress: 0,
                status: fileStatusDic.ing,
                name: file?.name.substring(0, file?.name.lastIndexOf('.')), //不要后缀
                size: file?.size,
                ext_type: ext_type
            });
        }
        setAgentFile(list);
        console.log(list, '选择完成');
    };
    //上传中
    const processFunc = (progress, file) => {
        let list = cloneDeep(agentFile);
        let curFile = list.find((ele) => ele.uid === file.uid);
        curFile.progress = progress;
        setAgentFile(list);
        console.log(progress, file, '进度');
    };
    //上传完成
    const afterUpload = (obsRes, file) => {
        console.log(obsRes, file, '上传完成');
        let list = cloneDeep(agentFile);
        let curFile = list.find((ele) => ele.uid === file.uid);
        curFile.progress = 1;
        curFile.status = fileStatusDic.success;
        curFile.file_url = obsRes.fileUrl;
        curFile.fingerprint = obsRes.md5;
        curFile.object_id = obsRes.objectKey;
        curFile.bucket = obsRes.bucketName;
        curFile.parse_status = parseStatusDic.success; //AI评阅的文件不需要解析，直接赋值解析完成
        setAgentFile(list);
    };
    const errorFunc = (error, file) => {
        if (error.message) {
            ToastUtils.showToast(error.message);
            console.log('文件已存在、类型不支持或大小超限');
        } else {
            let list = cloneDeep(agentFile);
            let curFile = list.find((ele) => ele.uid === file.uid);
            curFile.process = 0;
            curFile.status = 0;

            setAgentFile(list);
        }
    };
    return (
        <>
            <Upload
                onChange={onFileChange}
                disabled={props.disabled}
                processFunc={processFunc}
                completeFunc={afterUpload}
                bucketName={agentFileBucketName.oss}
                errorFunc={errorFunc}
                dirname={getAgentFileDirName()}
                uploadItem={props.children}
                {...UploadConfig}
            ></Upload>
        </>
    );
};
export default FileUpload;
